import * as i0 from '@angular/core';
import { EventEmitter, forwardRef, Output, Input, ViewEncapsulation, Component, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class E11InlineFooterComponent {
    constructor() {
        this.confirmIcon = 'check';
        this.cancelIcon = 'close';
        this.confirmDisabled = false;
        this.confirm = new EventEmitter();
        this.cancel = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InlineFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11InlineFooterComponent, selector: "e11-inline-footer", inputs: { confirmIcon: "confirmIcon", cancelIcon: "cancelIcon", confirmDisabled: "confirmDisabled" }, outputs: { confirm: "confirm", cancel: "cancel" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => E11InlineFooterComponent),
                multi: true,
            },
        ], ngImport: i0, template: `
    <div class="e11-flex e11-pb-1">
      <button class="e11-appearance-none e11-mr-1" type="submit">
        <div
          [title]="'Confirm'"
          (mousedown)="confirm.emit()"
          class="e11-flex e11-border e11-bg-skin-app-bg e11-border-skin-app-borders e11-w-6 e11-h-6 e11-items-center e11-justify-center"
          [ngClass]="{ 'e11-cursor-pointer': !confirmDisabled, 'e11-cursor-not-allowed e11-bg-skin-grey/20': confirmDisabled }"
        >
          <span class="material-icons-outlined md-14 e11-text-skin-success" [ngClass]="{ 'e11-text-skin-success': !confirmDisabled }">{{
            confirmIcon
          }}</span>
        </div>
      </button>
      <div
        [title]="'Cancel'"
        [tabIndex]="0"
        (mousedown)="cancel.emit()"
        class="e11-flex e11-border e11-bg-skin-app-bg e11-border-skin-app-borders e11-w-6 e11-h-6 e11-items-center e11-justify-center e11-cursor-pointer"
      >
        <span class="material-icons-outlined md-14">{{ cancelIcon }}</span>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InlineFooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'e11-inline-footer',
                    template: `
    <div class="e11-flex e11-pb-1">
      <button class="e11-appearance-none e11-mr-1" type="submit">
        <div
          [title]="'Confirm'"
          (mousedown)="confirm.emit()"
          class="e11-flex e11-border e11-bg-skin-app-bg e11-border-skin-app-borders e11-w-6 e11-h-6 e11-items-center e11-justify-center"
          [ngClass]="{ 'e11-cursor-pointer': !confirmDisabled, 'e11-cursor-not-allowed e11-bg-skin-grey/20': confirmDisabled }"
        >
          <span class="material-icons-outlined md-14 e11-text-skin-success" [ngClass]="{ 'e11-text-skin-success': !confirmDisabled }">{{
            confirmIcon
          }}</span>
        </div>
      </button>
      <div
        [title]="'Cancel'"
        [tabIndex]="0"
        (mousedown)="cancel.emit()"
        class="e11-flex e11-border e11-bg-skin-app-bg e11-border-skin-app-borders e11-w-6 e11-h-6 e11-items-center e11-justify-center e11-cursor-pointer"
      >
        <span class="material-icons-outlined md-14">{{ cancelIcon }}</span>
      </div>
    </div>
  `,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => E11InlineFooterComponent),
                            multi: true,
                        },
                    ],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], propDecorators: { confirmIcon: [{
                type: Input
            }], cancelIcon: [{
                type: Input
            }], confirmDisabled: [{
                type: Input
            }], confirm: [{
                type: Output
            }], cancel: [{
                type: Output
            }] } });

class E11InlineFooterModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InlineFooterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11InlineFooterModule, declarations: [E11InlineFooterComponent], imports: [CommonModule, ReactiveFormsModule], exports: [E11InlineFooterComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InlineFooterModule, imports: [CommonModule, ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InlineFooterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11InlineFooterComponent],
                    imports: [CommonModule, ReactiveFormsModule],
                    exports: [E11InlineFooterComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11InlineFooterComponent, E11InlineFooterModule };
